import { render, staticRenderFns } from "./LeadMagnetButton.vue?vue&type=template&id=18d5a1a4&scoped=true"
import script from "./LeadMagnetButton.vue?vue&type=script&lang=js"
export * from "./LeadMagnetButton.vue?vue&type=script&lang=js"
import style0 from "./LeadMagnetButton.vue?vue&type=style&index=0&id=18d5a1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d5a1a4",
  null
  
)

export default component.exports